import type { MissionsCampaign } from "@/campaigns/modules/missions/types";
import { allMissionsCompleted } from "@/campaigns/modules/missions/types";

import { FinishedCampaignCard } from "./finished-campaign-card";
import { Typography } from "@/components/ui/typography";
import { useTranslation } from "react-i18next";

/** "Ended 28 Jun" — null if the campaign end date doesn't parse. */
const formatEndDate = (end: unknown): string | null => {
  if (typeof end !== "string") return null;
  const d = new Date(end);
  if (Number.isNaN(d.getTime())) return null;
  return new Intl.DateTimeFormat(undefined, {
    day: "numeric",
    month: "short",
  }).format(d);
};

/**
 * Finished missions campaign in the results grid: the player's completion is
 * the result when they finished everything; otherwise the ended date (like
 * prize drops — there is no per-player "won" stream to show more).
 */
export const FinishedMissionsCard = ({
  missionsCampaign,
}: {
  missionsCampaign: MissionsCampaign;
}) => {
  const { t } = useTranslation();
  const ended = formatEndDate(missionsCampaign.campaign.end);

  if (allMissionsCompleted(missionsCampaign)) {
    return (
      <FinishedCampaignCard campaign={missionsCampaign.campaign}>
        <Typography tag="h5" className="text-prizes">
          {t("missions.allCompletedShort", "All missions completed")}
        </Typography>
      </FinishedCampaignCard>
    );
  }

  return (
    <FinishedCampaignCard campaign={missionsCampaign.campaign}>
      <Typography tag="h5" className="text-muted-foreground">
        {ended
          ? t("campaign.endedOn", "Ended {{date}}", { date: ended })
          : t("campaign.ended", "Ended")}
      </Typography>
    </FinishedCampaignCard>
  );
};
